module.exports = __webpack_public_path__ + "img/advantagesImg6.72cf9272.png";